import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { BITRIX_STORE } from '@shared/api/endpoints';
import { useBitrix24 } from '@shared/hooks/useBitrix24';
import { useTelegramStatus } from '@features/settings/hooks/useTelegram';
import type { StoreOrder } from '@tailorcast/shared-types';

interface OrdersResponse {
  orders: StoreOrder[];
  total: number;
  page: number;
  totalPages: number;
}

export function useOrders(page: number = 1, limit: number = 20) {
  const { isBitrix24 } = useBitrix24();
  const { data: telegramStatus } = useTelegramStatus();

  return useQuery({
    queryKey: ['store-orders', page, limit],
    queryFn: () => api.get<OrdersResponse>(`${BITRIX_STORE.ORDERS}?page=${page}&limit=${limit}`),
    enabled: isBitrix24 && telegramStatus?.linked === true,
    staleTime: 30_000,
  });
}
